<template>
<div class="page page_fans">
	<div class="" ref='vlist'>
		<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getData" :immediate-check="false">
			<div class="list" >
				<div class="item" v-for="item in dataList" :key="item.user_uuid">
					<div class="item_l">
						<img :src="item.user_thumb ? ( $publicData.withHttpStart(item.user_thumb) ? item.user_thumb : imageUrl+item.user_thumb) : $publicData.defaultTouxiang" alt="" class="thumb">
						<div class="user_name slh_s">{{ $publicData.formatPhone(item.user_name) }}</div>
					</div>
					<!-- <div class="item_r">
							<div class="action followed">已关注</div>
						</div> -->
				</div>
			</div>
		</van-list>
	</div>
    <!-- 无粉丝 -->
    <div class="page_default" ref="default" style="display:none">
        <div class="bg">
            <img :src="publicPath+'statics/images/no_fans.png'" alt="" class="bg_tu">
        </div>
        <div class="tips">还没有粉丝呦～</div>
    </div>
</div>

</template>

<script>
import Vue from 'vue';
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";
import Bridge from '../../../../.././vuex/bridge.js'
Vue.prototype.$bridge = Bridge
var userAgent = navigator.userAgent
export default {
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
            token: null,
			dataList: [],
			tradesmanId: this.$route.query.tradesmanId,
			pages: {
				page: 1,
				size: 10
			},
			loading: true,
			finished: false,
			tradesman_uuid: this.$route.query.tradesman_uuid // 匠人uuid
        };
    },
    created: function () {
        if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '粉丝列表'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            var memberParams = {
                'data': {}
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                console.log('sdjy://member/memberInfo')
                console.log(data)
                if (data.code == 200) {
                    this.token = data.result.token
                    this.getData()
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // this.getData()
                responseCallback({})
            })
        } else {
            this.token = this.$store.getters.token
            this.getData();
        }
        // // 获取列表
        // this.getData();
    },
    mounted() {
        // this.getData();
    },
    methods: {
        // 获取列表
        getData() {
            // if (this.token == null || this.token == undefined || this.token == '') {
            //     return
            // }
            var params = {
                // token: this.token,
                page: this.pages.page,
                size: this.pages.size
			}
			if(this.token){
				params.token = this.token
			}
            // if (this.tradesmanId != null && this.tradesmanId != undefined && this.tradesmanId != '') {
            //     params.id = this.tradesmanId
			// }
			if(this.tradesman_uuid != null){
				params.uuid = this.tradesman_uuid
			}
            console.log(params)
            this.$api.my.fansList(params).then(res => {
                if (res.code == 200) {
					var list = res.result
					// 判断 第一页有没有数据
					if(this.pages.page == 1 && !list){
						// 无数据
						$(this.$refs.vlist).css('display','none')
						$(this.$refs.default).css('display','block')	
					}else{
						// 有数据
						if(list.length != 0){
							for(var i in list) {
								this.dataList.push(list[i])
							}
							// 分页加载
							this.pages.page++
							this.loading = false
						}else if(list.length == 0){
							// 数据加载完毕
							this.finished = true
						}
					}
					
                } else {
					// 接口报错
					this.finished = true
                    this.$toast(res.message)
				}
				
				// console.log('page',this.pages.page,this.loading)
				// console.log('page----------',this.pages.page)
			})
			
			// console.log('this.dataList',this.dataList)
        },

    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
